import { Paragraph } from '@zillow/constellation-10';
import { useContext } from 'react';
import type { ConversationMessagesData } from '../../../../utils/conversationMessageUtils';
import { InboxPageContext } from '../../../../contexts/InboxPageContextProvider';
import { useConversationMessagesQuery } from '../../../../hooks/useConversationMessagesQuery';
import InboxSidebarSection from '../InboxSidebarSection';

export const EXPIRED_RENTER_PROFILE = 'Renter profiles expire after 90 days of no communication.';

export const selectIsRenterProfileHidden = (data: ConversationMessagesData): boolean =>
  data.renterProfile.isRenterProfileHidden;

const ExpiredRenterProfile = (): JSX.Element | null => {
  const { conversationId, clientTimeZone } = useContext(InboxPageContext);
  // Cache-only read — `MessageListItems` owns the `getMessages` fetch + polling.
  const { data: isRenterProfileHidden } = useConversationMessagesQuery({
    conversationId,
    clientTimeZone,
    enabled: false,
    select: selectIsRenterProfileHidden,
  });

  return isRenterProfileHidden ? (
    <InboxSidebarSection title="Renter Profile" shouldShowExpiredStatusLabel>
      <Paragraph textStyle="body-sm">{EXPIRED_RENTER_PROFILE}</Paragraph>
    </InboxSidebarSection>
  ) : null;
};

export default ExpiredRenterProfile;
